export function RiskPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Risk Management</h1>
      <p className="text-muted-foreground">Monitor and manage platform risk.</p>
    </div>
  );
}
